import { Checkbox } from '@ds';

const REDACTION_CONFIRMATION_LABEL =
  'I confirm that I have removed all information that could identify the donor before uploading.';

type RedactionConfirmationCheckboxProps = {
  isSelected: boolean;
  onValueChange: (isSelected: boolean) => void;
};

export const RedactionConfirmationCheckbox = ({ isSelected, onValueChange }: RedactionConfirmationCheckboxProps) => (
  <Checkbox size="sm" isSelected={isSelected} onValueChange={onValueChange} className="mr-auto">
    <span className="text-sm font-medium font-sans">{REDACTION_CONFIRMATION_LABEL}</span>
  </Checkbox>
);
